import { useEffect, useState } from "react";

export function useCountUp(target: number, duration = 900, decimals = 0) {
  const [v, setV] = useState(0);

  useEffect(() => {
    let raf = 0;
    const start = performance.now();
    const from = 0;
    const to = target;
    const ease = (t: number) => 1 - Math.pow(1 - t, 3); // easeOutCubic

    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / duration);
      const value = from + (to - from) * ease(t);
      setV(value);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  const factor = Math.pow(10, decimals);
  return Math.round(v * factor) / factor;
}

export function formatRu(n: number, decimals = 0) {
  if (decimals > 0) {
    return n.toFixed(decimals).replace(".", ".");
  }
  return Math.round(n).toLocaleString("ru-RU").replace(/\u00a0/g, " ");
}
